"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BREAKPOINTS = void 0;
// Cozy breakpoints with equivalency to MUI on xs, later we can use the tokens object.
var BREAKPOINTS = exports.BREAKPOINTS = {
  xs: 0,
  sm: 640,
  md: 960,
  lg: 1280,
  xl: 1920
};